import Service from "../../Services";

const Membership = {
  namespaced : true,
  state : {
    form : {
      branch_id : '',
      topic : '',
      title_en : '',
      title_th : '',
      description_th : '',
      description_en : '',
      slug_url : '',
      is_publish : true,
    },
  },
  mutations : {
    GET_FORM_MEMBERSHIP : (state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA : (state)=>{
      state.form = {
        branch_id : '',
        topic : '',
        title_en : '',
        title_th : '',
        description_th : '',
        description_en : '',
        slug_url : '',
        is_publish : true,
      }
    }
  },
  actions : {
    getMembership({commit},page){
      return Service.MembershipAPI.getMembership(page)
    },
    showMembership({commit},id){
      return Service.MembershipAPI.showMembership(id)
    },
    saveMembership({commit},{id,data}){
      if(id){ //update
        return Service.MembershipAPI.updateMembership(id,data);
      }else{ //create
        return Service.MembershipAPI.createMembership(data);
      }
    },
    deleteMembership({commit},id){
      return Service.MembershipAPI.deleteMembership(id)
    },
    setFormMembership({commit},res){
      commit('GET_FORM_MEMBERSHIP',res);
    },
    clearFormData({commit}){
      commit("CLEAR_FORM_DATA");
    }
  },
}
export default Membership
